const GetToken = () => {
  
  const JWT = () => {
    const tokenString = sessionStorage.getItem('jwt'); // Get stored token string

    if (!tokenString) return null; // Handle missing token case
  
    try {
      const tokenObject = JSON.parse(tokenString); // Parse JSON string to object
      return tokenObject; // Return only the token value
    } catch (error) {
      console.error("Invalid token format:", error);
      return null;
    }
  };

  const Refresh = () => {
    const tokenString = sessionStorage.getItem('refresh'); // Get stored token string
    if (!tokenString) return null; // Handle missing token case
  
    try {
      const tokenObject = JSON.parse(tokenString); // Parse JSON string to object
      return tokenObject; // Return only the token value
    } catch (error) {
      console.error("Invalid token format:", error);
      return null;
    }
  };

  return { JWT, Refresh }; // Return functions so they can be used
};

export default GetToken;
